
let language = {
    THIRD_PARTY_REGIST_FORM_NICKNAME_LABEL: "Full Name",
    THIRD_PARTY_REGIST_FORM_NICKNAME_PLACEHOLDER: "Please input your full name",
    THIRD_PARTY_REGIST_FORM_EMAIL_LABEL: "Email",
    THIRD_PARTY_REGIST_FORM_EMAIL_PLACEHOLDER: "Please input your social email address",
    THIRD_PARTY_REGIST_FORM_EMAIL_ERROR_TIP1: "Please enter the correct email address",
    THIRD_PARTY_REGIST_FORM_SUBMIT_BTN: "Sign up",
};

export { language }